var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDeleteProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icDeleteProfile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.3550055,30.5000564 L41.9198107,21.9352412 C42.7082113,21.1468397 42.7082113,19.8685916 41.9198107,19.0803028 C41.1314101,18.2919013 39.8532762,18.2919013 39.0648756,19.0803028 L30.4999577,27.6452308 L21.9350398,19.08019 C21.1466392,18.2917885 19.8685053,18.2917885 19.0801047,19.08019 C18.2918169,19.8685916 18.2918169,21.1468397 19.0801047,21.9351284 L27.6450227,30.4999436 L19.0801047,39.0648716 C18.2918169,39.8532731 18.2918169,41.1315212 19.0801047,41.91981 C19.8685053,42.7082115 21.1466392,42.7082115 21.9350398,41.91981 L30.4999577,33.354882 L39.0648756,41.91981 C39.8531634,42.7082115 41.1314101,42.7082115 41.9198107,41.91981 C42.7082113,41.1314084 42.7082113,39.8532731 41.9198107,39.0648716 L33.3550055,30.5000564 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icDeleteProfile",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,-3.55271368e-15 C13.5002729,-3.55271368e-15 -3.55271368e-15,13.5002729 -3.55271368e-15,30 C-3.55271368e-15,46.4997271 13.5002729,60 30,60 C46.4997271,60 60,46.4997271 60,30 C60,13.5002729 46.4997271,-3.55271368e-15 30,-3.55271368e-15 Z",
    id: "Stroke-1",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#7BCB45",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeleteProfile);
export default __webpack_public_path__ + "static/media/icDeleteProfile.2b478b0d103a752e440f15af0ce5acd4.svg";
export { ForwardRef as ReactComponent };